"use client";

import React from "react";
import Image from "next/image";

export default function CmaMilesoneNew() {
  return (
    <>
      <div className="w-full bg-center relative isolate md:py-8 py-10">
        {/* DESKTOP BG */}
        <div
          className="hidden md:block absolute inset-0 -z-10 pointer-events-none select-none"
          style={{ contain: "layout style paint" }}
        >
          <Image
            src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/new/download_app_dek_bg.webp"
            alt="CMA Visit Hero Section Background"
            fill
            className="object-cover"
            sizes="(min-width: 769px) 100vw, 0px"
            loading="lazy"
            quality={100}
          />
        </div>

        {/* MOBILE BG */}
        <div
          className="md:hidden absolute inset-0 -z-10 pointer-events-none select-none"
          style={{ contain: "layout style paint" }}
        >
          <Image
            src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/new/download_app_mob_bg.webp?tr=w-480,h-310,q-80"
            alt="CMA Visit Hero Section Bg Mob"
            fill
            className=""
            sizes="(max-width: 767px) 480px, 0px"
            loading="lazy"
            quality={80}
          />
        </div>

        {/* CONTENT */}
        <div className="max-w-[1340px] mx-auto relative px-4 md:px-6 lg:px-7 py-6 lg:py-16">
          <div className="flex flex-col md:items-center items-start md:text-center text-left md:space-y-8">
            <p className="text-base md:text-2xl text-white">Download the</p>

            <h2 className="text-3xl md:text-[84px] font-bold text-white tracking-tight">
              Miles One App
            </h2>

            <p className="text-base md:text-2xl text-white font-semibold">
              to be an AI-Ready Accountant
            </p>
          </div>

          <div className="flex flex-row gap-3 justify-start md:justify-center md:items-center md:mt-10 mt-4">
            <div
              className="bg-[#3D3D3D] p-2 flex rounded-lg w-[100px] md:w-auto gap-2 pr-4 md:pr-6"
              onClick={(e) => e.preventDefault()}
            >
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/home/app-store.webp?tr=w-48,h-49,q-80"
                alt="App Store"
                width={48}
                height={49}
                loading="lazy"
                className="shrink-0 w-6 h-6 md:w-[32px] md:h-[32px]"
              />
              <div>
                <p className="text-[8px] md:text-[10px] leading-3 text-white font-medium">
                  Download on
                </p>
                <p className="text-[10px] md:text-base text-white font-medium">
                  App Store
                </p>
              </div>
            </div>
            <div
              className="bg-[#3D3D3D] p-2 flex rounded-lg w-[100px] md:w-auto gap-2 pr-4 md:pr-6"
              onClick={(e) => e.preventDefault()}
            >
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/home/play-store.webp?tr=w-48,h-49,q-80"
                alt="Play Store"
                width={48}
                height={49}
                loading="lazy"
                className="shrink-0 w-6 h-6 md:w-[32px] md:h-[32px]"
              />
              <div>
                <p className="text-[8px] md:text-[10px] leading-3 text-white font-medium">
                  Download on
                </p>
                <p className="text-[10px] md:text-base text-white font-medium">
                  Play Store
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
